import React, { createContext, FC } from 'react'
import { StepTreePathChain } from './utils/stepPathChainManagement'
import { useStepTreePath } from './hooks/useStepTreePath'

type ContextState = { path?: string }
export const StepTreePathContext = createContext<ContextState>({})
const { Provider } = StepTreePathContext

export type Props = { newestPathLink: string }

const StepTreePathProvider: FC<Props> = ({ newestPathLink, children }) => {
  const parentPath = useStepTreePath()
  const childPath = new StepTreePathChain(parentPath).attachNewLink(newestPathLink).getPath()

  return <Provider value={{ path: childPath }}>{children}</Provider>
}

export default StepTreePathProvider
export type StepTreePathProviderProps = Props
